/**
 * Checks if the current user is a band if so it'll fetch bucket context.
 *
 * @param {object} context - The middleware base context.
 * @param {object} context.store - Store accessor.
 */
export default async function ({ store }) {
  if (store.getters["user/IS_BAND"]) {
    await store.dispatch("user/favorites/FETCH_BUCKETS")
    await store.dispatch("user/favorites/FETCH_INFLUENCERS")
  }
}
